import React from "react";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";
import {
  Padding,
  paddingLeftMap,
  paddingRightMap,
  paddingXMap,
  paddingYMap,
} from "apps/website/maps/Spacing.map";
import { MaxWidth, maxWidthClassMap } from "apps/website/maps/Size.map";

import { iconSvgMap } from "../Icon/Icon.map";
import Icon from "../Icon/Icon";
import TextSubtitle from "../Text/TextSubtitle/TextSubtitle";
import TextBody from "../Text/TextBody/TextBody";
import { Color } from "../Text/Text.map";

// To avoid magic numbers
const PADDING_LEFT_DEFAULT = 2;
const PADDING_RIGHT_DEFAULT = 3;

export const pillIconMap = {
  tick: iconSvgMap.tick,
  tickShort: iconSvgMap.tickShort,
  tickHeavy: iconSvgMap.tickHeavy,
  crossHeavy: iconSvgMap.crossHeavy,
};

export interface IPillProps {
  icon?: keyof typeof pillIconMap;
  iconClassName?: string;
  label: string;
  className?: string;
  styleOptions?: {
    bgColor?: Theme,
    textColor?: Color,
    paddingY?: Padding,
    paddingX?: Padding,
    paddingLeft?: Padding,
    paddingRight?: Padding,
    maxWidth?: MaxWidth,
    textDisplay?: "subtitle" | "body"
  };
}

export const Pill = ({ icon, iconClassName, label, className, styleOptions }: IPillProps) => {
  const {
    bgColor = "default",
    textColor = "default",
    paddingY,
    paddingX,
    paddingLeft,
    paddingRight,
    maxWidth = "full",
    textDisplay,
  } = styleOptions ?? {};

  const pillClassName = cx(
    "inline-flex items-center gap-1 rounded-3xl",
    themeRootClassMap[bgColor],
    paddingXMap[paddingX ?? 0],
    paddingY ? paddingYMap[paddingY] : "py-1.5",
    paddingLeftMap[paddingLeft ?? paddingX ?? PADDING_LEFT_DEFAULT],
    paddingRightMap[paddingRight ?? paddingX ?? PADDING_RIGHT_DEFAULT],
    maxWidthClassMap[maxWidth],
    className,
  );

  return (
    <div data-component={Pill.name} className={pillClassName}>
      { icon && (
        <div className="flex items-center justify-center w-4 h-4 shrink-0">
          <Icon icon={icon} size="fit" className={iconClassName} />
        </div>
      ) }
      { textDisplay === "body" ? (
        <TextBody size={3} color={textColor} className="leading-none">
          { label }
        </TextBody>
      ) : (
        <TextSubtitle size={3} color={textColor} className="leading-none">
          { label }
        </TextSubtitle>
      ) }
    </div>
  );
};
